;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Menu_a674857b22f457032fdf45574bf1e1a1\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <g> <rect x=\"15.213\" y=\"75.918\" width=\"69.574\" height=\"4.572\"/> <rect x=\"15.213\" y=\"57.115\" width=\"69.574\" height=\"4.574\"/> <rect x=\"15.213\" y=\"38.312\" width=\"69.574\" height=\"4.574\"/> <rect x=\"15.213\" y=\"19.509\" width=\"69.574\" height=\"4.574\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Menu_a674857b22f457032fdf45574bf1e1a1");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Menu.svg
// module id = 1409
// module chunks = 0